package com.gsb.vyapar.bhagya.presentation.navigation.view

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.Icon
import androidx.compose.material.IconButton
import androidx.compose.material.ScaffoldState
import androidx.compose.material.TopAppBar
import org.jetbrains.compose.resources.painterResource
import com.gsb.vyapar.bhagya.theme.account_circle
import com.gsb.vyapar.bhagya.theme.location_icon
import com.gsb.vyapar.bhagya.theme.menu_icon
import com.gsb.vyapar.bhagya.theme.search_icon
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.BitmapPainter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import androidx.navigation.NavHostController
import androidx.navigation.compose.currentBackStackEntryAsState
import com.gsb.vyapar.bhagya.domain.getImage
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.Screens
import com.gsb.vyapar.bhagya.presentation.auth.util.isUserLoggedIn
import com.gsb.vyapar.bhagya.presentation.common.image.PlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.image.SmoothImageRound
import com.gsb.vyapar.bhagya.presentation.common.text.Text16Medium
import com.gsb.vyapar.bhagya.presentation.navigation.util.onAccountClick
import com.gsb.vyapar.bhagya.presentation.navigation.util.pushView
import com.gsb.vyapar.bhagya.presentation.search.uistate.getSearchUiState
import com.gsb.vyapar.bhagya.presentation.location.util.showPincodeDialog
import com.gsb.vyapar.bhagya.theme.primary
import com.gsb.vyapar.bhagya.util.BLANK_PROFILE
import com.gsb.vyapar.bhagya.util.value
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch

@Composable
fun NavigationTopBar(
    uiState: UiState,
    navController: NavHostController,
    scaffoldState: ScaffoldState,
    scope: CoroutineScope
) {
    val navBackStackEntry by navController.currentBackStackEntryAsState()
    val currentRoute = navBackStackEntry?.destination?.route
    TopAppBar(
        title = {
            Text16Medium(text = currentRoute.orEmpty(), color = Color.White)
        },
        navigationIcon = {
            IconButton(onClick = { scope.launch { scaffoldState.drawerState.open() } }) {
                Icon(painter = painterResource(menu_icon), contentDescription = "Drawer")
            }
        },
        actions = {
            IconButton(onClick = { showPincodeDialog() }) {
                Icon(painter = painterResource(location_icon), contentDescription = "Location")
            }
            IconButton({
                getSearchUiState().resetSearch()
                pushView(Screens.Search)
            }) {
                Icon(painter = painterResource(search_icon), contentDescription = "Search")
            }
            IconButton(onClick = { scope.launch { onAccountClick() } }) {
                if (isUserLoggedIn()) {
                    SmoothImageRound(
                        uiState.getImage(uiState.getUser().getImage().ifEmpty { BLANK_PROFILE.value() }),
                        width = 35.dp,
                        height = 35.dp
                    )
                } else {
                    Icon(painter = painterResource(account_circle), contentDescription = "Account")
                }
            }
        },
        contentColor = Color.White,
        elevation = 12.dp,
        backgroundColor = primary,
    )
}